import { Query, QueryKey } from '@tanstack/react-query';

export default function staleQueryIfNotError<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = readonly unknown[],
>(staleTime: number) {
  return {
    staleTime: (query: Query<TQueryFnData, TError, TData, TQueryKey>) => {
      // don't stale if the query has errors
      if (query.state.error) return 0;
      return staleTime;
    },
  };
}
